export default __webpack_public_path__ + "static/media/Logo.4b7e0891.png";